import { render } from "./QuickpayPaymentFeedback.vue?vue&type=template&id=73235ddd&scoped=true"
import script from "./QuickpayPaymentFeedback.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentFeedback.vue?vue&type=script&lang=js"

import "./QuickpayPaymentFeedback.vue?vue&type=style&index=0&id=73235ddd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73235ddd"]])

export default __exports__